import { z } from "zod";

export const PostIntakeSubmissionApprovalInputSchema = z.object({
  status: z.enum(["APPROVED", "REJECTED"]),
  comment: z.string().optional(),
  levelGroupStatusId: z.string(),
  approveAllNonTaskBlocks: z.boolean().optional(),
});

export type PostIntakeSubmissionApprovalInput = z.infer<
  typeof PostIntakeSubmissionApprovalInputSchema
>;
